<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :title="title"
    :visible="dialogVisible"
    :before-close="beforeClose"
    append-to-body
    :wrapperClosable="false"
    :close-on-press-escape="false"
    ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <el-form style="padding: 20px" ref="form" :model="tempValue" label-width="80px" :rules="rules" :inline="true">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="模板名称" prop="name"> <eco-input v-model="tempValue.name" style="width: 100%" /> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="模版绑定" prop="boDefId">
            <el-select filterable disabled v-model="tempValue.boDefId" style="width: 100%">
              <el-option v-for="item in boDefIdList" :key="item.id" :value="item.id" :label="item.description"></el-option>
            </el-select> </el-form-item></el-col
      ></el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="模板别名" prop="alias" required>
            <eco-input v-model="tempValue.alias" disabled style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模版用途" prop="purpose">
            <el-select v-model="tempValue.purpose" style="width: 100%">
              <el-option v-for="item in purposeList" :key="item.code" :value="item.code" :label="item.name"></el-option>
            </el-select> </el-form-item></el-col
      ></el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="表单别名" prop="formKey">
            <el-select v-model="tempValue.formKey" style="width: 100%">
              <el-option v-for="item in formKeyList" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-form-item> </el-col
      ></el-row>
      <el-form-item label="合同模板" prop="file" required>
        <!-- 模板上传 -->
        <eip-import-material
          ref="eipImport"
          model-name="importList"
          propConf='[{"name":"prop1"}]'
          accept="docx"
          limit="1"
          displayType="table"
          :multiple="false"
          :importsuccess="true"
          :importurl4="importurlWl"
          @emitFile="emitFile"
          @clearFile="clearFile"
          :value="tempValue.file"
        >
          <span slot="labeldesc">合同模板</span>
        </eip-import-material>
      </el-form-item>
    </el-form>
    <!-- 模板实体table -->
    <temp-object-table :defId="tempValue.boDefId" :templateData="tempValue.form_contract_template_detail"></temp-object-table>
    <div class="demo-drawer__footer" v-if="title == '编辑模板'">
      <el-button @click="beforeClose">取消</el-button>
      <el-button @click="submit('form')" type="primary" :loading="tempAddLoading">确定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import form from '@/api/form.js'
import req from '@/request'
import * as constants from './constants'
import eipImportMaterial from '@/components/eipControl/EipImportMaterial.vue'
const tempObjectTable = () => import('@/views/form/htmb/tempObjectTable.vue')
export default {
  name: 'tempAdd',
  props: {
    title: String,
    selectModel: String,
    dialogVisible: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    eipImportMaterial,
    tempObjectTable
  },
  data() {
    return {
      drawerSize: '70%',
      tempValue: {
        name: '',
        boDefId: '',
        purpose: '',
        alias: '',
        file: '',
        formKey: '',
        form_contract_template_detail: []
      },
      boDefIdList: [],
      formKeyList: [],
      fileList: [],
      tempAddLoading: false,
      pageBean: {
        page: 1,
        pageSize: 999,
        total: 0
      },
      rules: {
        name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        boDefId: [{ required: true, message: '请选择模板绑定', trigger: 'change' }],
        formKey: [{ required: true, message: '请选择表单别名', trigger: 'change' }],
        purpose: [{ required: true, message: '请选择模板用途', trigger: 'change' }],
        file: [{ required: true, message: '请上传模板', trigger: 'change, blur' }]
      },
      selectUploadId: '',
      importurlWl: req.getContext().manage + req.getContext().portal + '/system/file/v1/upload',
      ...constants
    }
  },
  mounted() {
    this.getBoDefIdList()
    if (this.selectModel) this.temModifyTrans()
  },
  watch: {
    selectModel(newVal) {
      if (newVal) this.temModifyTrans()
    },
    'tempValue.boDefId'(newVal) {
      if (newVal) {
        this.getFormKeyList(newVal)
      }
    }
  },
  methods: {
    clearFile() {
      this.tempValue.file = ''
      this.tempValue.form_contract_template_detail = []
    },
    temModifyTrans() {
      let params = {
        id: this.selectModel
      }
      const detailUrl = this.title == '查看模板' ? 'getIezuDetailListById' : 'getDetailListById'
      form[detailUrl](params).then((res) => {
        this.tempValue = res
      })
    },
    beforeClose() {
      this.$refs['form'].resetFields()
      this.$emit('beforeClose')
      this.tempValue = {
        name: '',
        boDefId: '',
        purpose: '',
        alias: '',
        file: '',
        formKey: '',
        form_contract_template_detail: []
      }
    },
    // 获取模板用途列表
    getBoDefIdList() {
      let params
      this.pageBean.total = 0
      params = {
        pageBean: '',
        sorter: []
      }
      params.pageBean = this.pageBean
      form.getBusinessObjData(params).then((resp) => {
        this.boDefIdList = resp.rows
      })
    },
    // 获取模板用途列表
    getFormKeyList(param) {
      this.selName(param, 'boDefName', this.boDefIdList)
      let params = {
        boDefId: param
      }
      form.getListByBoDefId(params).then((resp) => {
        this.formKeyList = resp
      })
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        this.tempAddLoading = true
        if (valid) {
          let params = Object.assign({}, this.tempValue)
          form
            .getContractTemplateSave(params)
            .then(() => {
              this.tempAddLoading = false
              this.beforeClose()
            })
            .catch(() => {
              this.tempAddLoading = false
            })
        } else {
          this.tempAddLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    emitFile(value) {
      let params = {
        id: this.selectModel,
        fileId: value.file.response.fileId
      }
      form.getDetailListByFileId(params).then((resp) => {
        this.tempValue.file = JSON.stringify(value.fileList)
        this.tempValue.form_contract_template_detail = resp
        this.$refs['form'].clearValidate('file')
      })
    },
    /**
     *
     * @param aa value
     * @param bb 赋值name
     * @param list 查找的list
     * @param listKey code转换
     */
    selName(aa, bb, list, listKey = 'code') {
      let temp = list.find((item) => item[listKey] === aa)
      this.tempValue[bb] = temp ? temp[bb] : ''
    }
  }
}
</script>

<style scoped>
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-form-item__content {
  width: calc(100% - 80px);
}
</style>
